import { Component } from '@angular/core';
import { environment } from '../../../Environment/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
   AssetbasePath = environment.assetsPath;
}
